<template>
<div>
  <CadastreSeCompradorDialog 
    :item="comprador" 
    @onCancela="efetuaLogin"
    titulo="Cadastro Comprador Catálogo PetroSupply - POLOS SEBRAE ONSHORE, OFFSHORE E ABPIP"
    v-model="cadastreSeDialogOpenedComprador"/>
  <CadastreSeFornecedorDialog 
    :item="fornecedor" 
    @onCancela="efetuaLogin"
    titulo="Cadastro Fornecedor Catálogo PetroSupply - POLOS SEBRAE ONSHORE, OFFSHORE E ABPIP"
    v-model="cadastreSeDialogOpenedFornecedor"/>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-fade-transition>
        <v-progress-linear v-if="loading" color="#efc00f" indeterminate height="5px"/>
      </v-fade-transition>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="6">
            <v-card class="opcao-acesso">
              <div class="opcao-acesso__titulo">
                <v-icon color="#167ABC" class="mr-2">mdi-account-check-outline</v-icon>
                Já sou cadastrado
              </div>
              <p class="opcao-acesso__texto">Informe seus dados de acesso vinculado a sua empresa, para prosseguir com sua inscrição.</p>
              <v-row dense>
                <v-col cols="6" class="pb-0">
                  <v-text-field
                      solo
                      dense
                      :rules="[
                        this.$validators.string.required,
                        this.$validators.string.notEmpty,
                      ]"
                      :disabled="loading"
                      placeholder="Informe seu e-mail"
                      v-model="login">
                    <template v-slot:append>
                      <div style="color:white;"><v-icon color="#efc00f">mdi-account</v-icon></div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" md="4" class="pb-0">
                  <v-text-field
                      solo
                      dense
                      :disabled="loading"
                      :placeholder="'Digite sua Senha'"
                      autocomplete="off"
                      v-model="password"
                      @keyup.enter="onEnterClick"
                      :rules="[
                        this.$validators.string.required,
                        this.$validators.string.notEmpty,
                      ]"
                      :type="showPassword ? 'text' : 'password'">
                    <template v-slot:append>
                      <div style="color:white;">
                        <v-icon @click="showPassword = !showPassword" color="#efc00f">{{showPassword ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-btn class="btn-primary" @click="onEnterClick" :disabled="loading || !valid" block>Entrar</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card class="opcao-acesso" :class="{'opcao-acesso--ativa': modoAcesso === 'cadastro'}">
              <div class="opcao-acesso__titulo">
                <v-icon color="#167ABC" class="mr-2">mdi-account-plus-outline</v-icon>
                Quero me cadastrar
              </div>
              <p class="opcao-acesso__texto">Ainda não tenho acesso e preciso realizar meu cadastro e o da minha empresa para continuar.</p>
              <v-btn class="btn-primary" @click="selecionarModo('cadastro')" :disabled="loading" block>
                Ir para o Cadastro
              </v-btn>
            </v-card>
          </v-col>
        </v-row>                          
      </v-col>
    </v-row>      
  </v-form>
</div>
</template>

<script>
import {mapActions} from "vuex";
import SearchBox from "../../../components/shared/common/SearchBox";
import {ApiError} from "../../../api/core";
import CadastreSeFornecedorDialog from "../../Fornecedor/CadastreSeFornecedorDialog";
import CadastreSeCompradorDialog from "../../Comprador/CadastreSeCompradorDialog";

export default {
  name: "AutenticacaoForm",
  components: {SearchBox, CadastreSeFornecedorDialog, CadastreSeCompradorDialog},
  props: {
    autenticacao: {
      type: Object
    },
    tipoContaSelecionado: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      valid: false,
      loading: false,
      modoAcesso: null,
      login: '',
      password: '',
      showPassword: false,
      //dialogs do cadastre-se
      comprador: {
        id: null,
        idAtividadeEconomica: null,
        descricaoAtividadeEconomica: "",
        nomeFantasia: "",
        razaoSocial: "",
        descricao: "",
        flgEmpresaEstrangeira: "N",
        cnpj: "",
        senha: "",
        endereco: "",
        bairro: "",
        complemento: "",
        cidade: "",
        estado: "",
        cep: "",
        pais: "",
        telefone: "",
        email: "",
        siteRede: "",
        contatos: [],
        contatosParaCadastro: "",       
      },
      cadastreSeDialogOpenedComprador: false,
      fornecedor: {
        id: null,
        idSetor: null,
        descricaoSetor: "",
        idPorte: null,
        descricaoPorte: "",
        idRamoAtuacao: null,
        descricaoRamoAtuacao: "",
        nomeFantasia: "",
        razaoSocial: "",
        descricao: "",
        flgEmpresaEstrangeira: "N",
        cnpj: "",
        senha: "",
        endereco: "",
        bairro: "",
        complemento: "",
        cidade: "",
        estado: "",
        cep: "",
        pais: "",
        telefone: "",
        email: "",
        siteRede: "",
        contatos: [],
        ofertas: [],
        ofertasParaCadastro: "",
        contatosParaCadastro: "",
      },
      cadastreSeDialogOpenedFornecedor: false,
    }
  },
  methods: {
    ...mapActions('auth', ['doLoginFornCompEmAnalise']),
    validarTipoContaSelecionado() {
      if (!this.tipoContaSelecionado) {
        this.$toast.error(`Selecione em "Identificação da Conta" a opção Fornecedor ou Comprador!`, {
          timeout: 6000
        })
        return false;
      }
      return true;
    },
    selecionarModo(modo) {
      if (!this.validarTipoContaSelecionado()) return;

      this.modoAcesso = modo;
      if (modo === 'cadastro') {
        this.direcionaTela();
      }
    },
    async efetuaLogin(tela, payload) {
      if (tela !== 'login') return;

      if (payload && payload.login && payload.password) {
        this.login = payload.login;
        this.password = payload.password;
        await this.onEnterClick();
        return;
      }
    },
    async onEnterClick() {
      if (!this.validarTipoContaSelecionado()) return;
      if(!this.$refs.form.validate()) return;
      try {
        this.loading = true;
        // //TO-DO: remover quando fizer o commit  
        // if (this.tipoContaSelecionado === 'fornecedor') {
        //   // this.login = "testesilva@outlook.com"; 
        //   this.login = "fabriciogondim.silva@outlook.com"; 
        //   this.password = "teste678";
        //   // this.login = "fabriciogondim.silva@outlook.com"; 
        //   // this.password = "teste123";
        // } else if (this.tipoContaSelecionado === 'comprador') {
        //   this.login = "fabriciojohnjohn@gmail.com";
        //   this.password = "teste654";
        // }
        const dadosLogin = await this.doLoginFornCompEmAnalise({
          type: this.tipoContaSelecionado,
          login: this.login,
          password: this.password
        });
        // Emite evento para o pai com os dados do login
        this.$emit('onLogin', {
          token: dadosLogin.token,
          current: dadosLogin.current,
          encontrou: 1
        });
      } catch (err) {
        if (err instanceof ApiError) {
          if (err.message==="duplicado"){
            this.$toast.error(`Mais de um responsável encontrado com as credencias fornecidas. Entre em contato com a administração!`, {
              timeout: 6000
            })
          } else {
            this.$toast.error(err.message, {
              timeout: 6000
            })
          }
        } else {
          this.$toast.error(`Não foi possível efetuar o login. Entre em contato com a administração!`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    },
    direcionaTela() {
      if (this.tipoContaSelecionado === 'fornecedor') {
        this.cadastreSeDialogOpenedFornecedor = true;
      } else if (this.tipoContaSelecionado === 'comprador') {
        this.cadastreSeDialogOpenedComprador = true;
      }
    },
  }
}
</script>

<style scoped>
  .btn-primary {
    background-color: #EFC00F !important;
    color: #ffffff !important;
    border: none;
  }

  .btn-primary:hover {
    background-color: #2EAB66 !important;
  }

  .click-aqui {
    color: #76acce;
  }

  .opcao-acesso {
    border: 1px solid #dce9f4;
    border-radius: 12px;
    padding: 16px;
    height: 100%;
    box-shadow: none;
  }

  .opcao-acesso--ativa {
    border-color: #167ABC;
    box-shadow: 0 0 0 1px #167ABC;
  }

  .opcao-acesso__titulo {
    color: #167ABC;
    font-weight: 700;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
  }

  .opcao-acesso__texto {
    margin: 0 0 12px 0;
    color: #5d6f80;
  }

  .btn-opcao {
    color: #167ABC;
    border: 1px solid #167ABC;
    background: #ffffff;
  }

  /*INPUTS*/
  ::v-deep .v-input__control .v-input__slot .v-text-field__slot input {
    background-color: #ffffff !important;
  }

</style>